#import "../fragments/domain-fragment.graphql"

mutation CheckDomain($input: DomainCheckInput!) {
    domainCheck(input: $input) {
        domain {
            ...DomainFragment
        }
    }
}
